// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/rbac.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PermissionEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/rbac.proto.
 */
export const file_cortado_v1_rbac: GenFile = /*@__PURE__*/
  fileDesc("ChVjb3J0YWRvL3YxL3JiYWMucHJvdG8SCmNvcnRhZG8udjEiqwEKBFJvbGUSCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEgwKBG5hbWUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSLwoLcGVybWlzc2lvbnMYBSADKA4yGi5jb3J0YWRvLnYxLlBlcm1pc3Npb25FbnVtEhcKD3Blcm1pc3Npb25fa2V5cxgGIAMoCRIRCglpc19zeXN0ZW0YByABKAhCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_cortado_v1_settings]);

/**
 * @generated from message cortado.v1.Role
 */
export type Role = Message<"cortado.v1.Role"> & {
  /**
   * ID of the role
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID of the role
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Name of the role
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * Description of the role
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Deprecated: use permission_keys. Retained for backward compatibility until
   * clients migrate to the string-keyed vocabulary; removed in a later phase.
   *
   * @generated from field: repeated cortado.v1.PermissionEnum permissions = 5;
   */
  permissions: PermissionEnum[];

  /**
   * Permission keys held by the role, e.g. ["Admin"] or ["ContactsView", "LeadsManage"]
   *
   * @generated from field: repeated string permission_keys = 6;
   */
  permissionKeys: string[];

  /**
   * True for the org's built-in, undeletable admin role (OrganizationAdmin)
   *
   * @generated from field: bool is_system = 7;
   */
  isSystem: boolean;
};

/**
 * Describes the message cortado.v1.Role.
 * Use `create(RoleSchema)` to create a new message.
 */
export const RoleSchema: GenMessage<Role> = /*@__PURE__*/
  messageDesc(file_cortado_v1_rbac, 0);

